/**
 * getUrlFromLinks
 *
 * @param {Array}  links
 * @param {String} type
 *
 * @returns {string}
 */
export default function getUrlFromLinks(links, type) {
  if (!links || !type) {
    return null;
  }

  return links.find((link) => link.type === type)?.url || null;
}
